import TabGrid from "components/cards/TabCardGrid.js";
import DownloadApp from "components/cta/DownloadApp.js";
import Features from "components/features/ThreeColSimple.js";
import MainFeature2 from "components/features/TwoColSingleFeatureWithStats2.js";
import MainFeature from "components/features/TwoColWithButton.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import Hero from "components/hero/TwoColumnWithVideo.js";
import Testimonial from "components/testimonials/TwoColumnWithImage.js";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import FAQ from "components/faqs/TwoColumnPrimaryBackground"

import celebrationIconImageSrc from "images/celebration-icon.svg";
import chefIconImageSrc from "images/chef-icon.svg";
import shopIconImageSrc from "images/shop-icon.svg";

export default () => {
  const Subheading = tw.span`tracking-wider text-sm font-medium`;
  const HighlightedText = tw.span`bg-black text-gray-100 px-4 transform -skew-x-12 inline-block`;
  const HighlightedTextInverse = tw.span`bg-gray-100 text-primary-500 px-4 transform -skew-x-12 inline-block`;
  const Description = tw.span`inline-block mt-1 text-black font-thin`;
  const imageCss = tw`border-white`;
  return (
    <AnimationRevealPage>
      <Hero
        heading={<>Elektroniczne<HighlightedText>Etykiety Cenowe</HighlightedText></>}
        description={
          <Description>
            Serwis do zdalnego zarządzania elektronicznymi etykietami cenowymi (ESL) to zaawansowane oprogramowanie umożliwiające centralne zarządzanie, monitorowanie i aktualizowanie etykiet cenowych w różnych lokalizacjach, często w czasie rzeczywistym. Tego typu serwis jest niezbędny w dużych sieciach detalicznych, aptekach, inteligentnych biurach czy magazynach, gdzie zmiana cen, promocji czy dostępności produktów wymaga szybkiej i efektywnej reakcji. Dzięki integracji z systemami ERP, POS oraz innymi technologiami, takie rozwiązania oferują wysoką efektywność, elastyczność i dokładność, co pozwala na osiągnięcie znacznych oszczędności operacyjnych i poprawę doświadczeń klientów.
            {/* Serwis SaaS do zdalnego zarządzania ekspozycją w wielu placówkach w jednym czasie. 
            Zintegrowany z elektronicznymi etykietami cenowymi (ESL) oraz lokalnym systemem sprzedażowym automatycznie aktualizuje informacje o produktach na półkach. Etykiety wykonane są w technologii e-papieru i są ekologiczną odpowiedzią na ekrany LED-owe ponieważ pobierają zdecydowanie mniej energii.
            Wyświetlacz wykonany w wysokiej rozdzielczości. Szeroki wybór rozmiarów. Wdrożenia w chmurze lub on premieses, możliwa integracja API. Indywidualne wyceny. */}
          </Description>
        }
        imageSrc="pic1_N.png"
        imageCss={imageCss}
        // imageDecoratorBlob={true}
        primaryButtonText="Zamów bezpłatną wycenę"
        primaryButtonUrl="#Kontakt"
        watchVideoButtonText="Zobacz film"
      />
      <MainFeature
        subheading={<Subheading></Subheading>}
        heading={
          <>
            Branża
            <HighlightedText> Detaliczna</HighlightedText>
            <wbr />
          </>
        }
        description={
          <Description>
            Elektroniczne etykiety cenowe (ESL – Electronic Shelf Labels) w branży detalicznej to innowacyjne rozwiązanie, które zyskuje coraz większą popularność w sklepach stacjonarnych, sieciach handlowych oraz supermarketach. Etykiety te są stosowane na półkach, gdzie wyświetlają ceny produktów, a także dodatkowe informacje, takie jak promocje, dostępność towaru, skład czy inne dane dotyczące towaru. Zamiast tradycyjnych papierowych etykiet, które wymagają manualnej wymiany i aktualizacji, ESL działają w sposób zautomatyzowany, co niesie za sobą wiele korzyści.
          </Description>
        }
        buttonRounded={false}
        textOnLeft={false}
        primaryButtonText="Więcej -->"
        primaryButtonUrl="#ESL_w_branzy_detalicznej"
        imageSrc="supermarket_org.jpg"
        imageCss={imageCss}
        // imageDecoratorBlob={true}
        //imageDecoratorBlobCss={tw`left-1/2 -translate-x-1/2 md:w-32 md:h-32 opacity-25`}
      />
      <MainFeature
        subheading={<Subheading></Subheading>}
        heading={
          <>
            Branża
            <HighlightedText> Farmaceutyczna</HighlightedText>
            <wbr />
          </>
        }
        description={
          <Description>
            Elektroniczne etykiety cenowe w branży farmaceutycznej oferują szereg korzyści, które mogą znacząco wpłynąć na poprawę efektywności operacyjnej aptek, a także poprawić doświadczenia Pacjentów dzięki lepszej i bardziej przejrzystej informacji o produktach. Choć początkowe koszty mogą być wysokie, długofalowe korzyści związane z automatyzacją, dokładnością i zgodnością z regulacjami sprawiają, że inwestycja w ESL staje się coraz bardziej opłacalna.
          </Description>
        }
        buttonRounded={false}
        textOnLeft={false}
        primaryButtonText="Więcej -->"
        primaryButtonUrl="#ESL_w_aptekach"
        imageSrc="apteka1.jpg"
        imageCss={imageCss}
        // imageDecoratorBlob={true}
        // imageDecoratorBlobCss={tw`left-1/2 -translate-x-1/2 md:w-32 md:h-32 opacity-25`}
      />
      <MainFeature
        subheading={<Subheading></Subheading>}
        heading={
          <>
            Inteligentne
            <HighlightedText> Biura</HighlightedText>
            <wbr />
          </>
        }
        description={
          <Description>
            Elektroniczne etykiety cenowe (ESL) w inteligentnych biurach to innowacyjne rozwiązanie, które wychodzi poza tradycyjny kontekst handlowy, znajdując zastosowanie w nowoczesnych przestrzeniach biurowych. Chociaż systemy ESL są najczęściej kojarzone z branżą detaliczną, to w inteligentnych biurach ich implementacja może przynieść szereg korzyści, zarówno z perspektywy zarządzania przestrzenią, jak i optymalizacji procesów.
          </Description>
        }
        buttonRounded={false}
        textOnLeft={false}
        primaryButtonText="Więcej -->"
        primaryButtonUrl = "#ESL_w_biurach"
        imageSrc="pic4_N.png"
        imageCss={imageCss}
        // imageDecoratorBlob={true}
        // imageDecoratorBlobCss={tw`left-1/2 -translate-x-1/2 md:w-32 md:h-32 opacity-25`}
      />
      <MainFeature
        subheading={<Subheading></Subheading>}
        heading={
          <>
            Inteligentne
            <HighlightedText>Magazyny</HighlightedText>
            <wbr />
          </>
        }
        description={
          <Description>
            Elektroniczne etykiety cenowe (ESL) w inteligentnych magazynach to nowoczesne rozwiązanie, które znacząco wykracza poza tradycyjne zastosowania w handlu. W środowisku magazynowym technologia ESL otwiera zupełnie nowe możliwości w zakresie automatyzacji, efektywnego zarządzania stanami oraz usprawnienia procesów logistycznych. Dzięki cyfrowym etykietom możliwe jest dynamiczne oznaczanie lokalizacji, szybka aktualizacja danych operacyjnych oraz pełna synchronizacja informacji z systemami WMS. W rezultacie wdrożenie ESL w magazynie przekłada się na wyższą wydajność pracy, redukcję błędów i lepszą organizację przestrzeni.
          </Description>
        }
        buttonRounded={false}
        textOnLeft={false}
        primaryButtonText="Więcej -->"
        primaryButtonUrl = "#ESL_w_magazynach"
        imageSrc="magazyny_org.jpg"
        imageCss={imageCss}
        // imageDecoratorBlob={true}
        // imageDecoratorBlobCss={tw`left-1/2 -translate-x-1/2 md:w-32 md:h-32 opacity-25`}
      />
      {/* TabGrid Component also accepts a tabs prop to customize the tabs and its content directly. Please open the TabGrid component file to see the structure of the tabs props.*/}
      <TabGrid
        heading={
          <>
            Modele <HighlightedText>i rozmiary:</HighlightedText>
          </>
        }
      />
      {/* <Features
        heading={
          <>
            Dostarczamy <HighlightedText>Branze.</HighlightedText>
          </>
        }
        cards={[
          {
            imageSrc: shopIconImageSrc,
            title: "230+ Locations",
            description: "Lorem ipsum donor amet siti ceali placeholder text",
            url: "https://google.com"
          },
          {
            imageSrc: chefIconImageSrc,
            title: "Professional Chefs",
            description: "Lorem ipsum donor amet siti ceali placeholder text",
            url: "https://timerse.com"
          },
          {
            imageSrc: celebrationIconImageSrc,
            title: "Birthday Catering",
            description: "Lorem ipsum donor amet siti ceali placeholder text",
            url: "https://reddit.com"
          }
        ]}

        imageContainerCss={tw`p-2!`}
        imageCss={tw`w-20! h-20!`}
      /> */}

      <FAQ></FAQ>
      <MainFeature2
        // subheading={<Subheading>A Reputed Brand</Subheading>}
        heading={<>Dlaczego warto z nami <HighlightedText>współpracować?</HighlightedText></>}
        statistics={[
          {
            key: "Klienci",
            value: "50+"
          },
          {
            key: "Projekty",
            value: "60+"
          },
          {
            key: "Serwisy",
            value: "2"
          }
        ]}
        primaryButtonText="Skontaktuj się z nami"
        primaryButtonUrl="https://datagrit.pl"
        imageInsideDiv={false}
        imageSrc="pic5.png"
        imageCss={Object.assign(tw`bg-cover`, imageCss)}
        imageContainerCss={tw`md:w-1/2 h-auto`}
        // imageDecoratorBlob={true}
        // imageDecoratorBlobCss={tw`left-1/2 md:w-32 md:h-32 -translate-x-1/2 opacity-25`}
        textOnLeft={true}
      />
      {/* <Testimonial
        subheading=""
        heading={<>Poznaj opnie <HighlightedText>naszych Klientów.</HighlightedText></>}
      /> */}
      {/* <DownloadApp
        text={<>People around you are ordering delicious meals using the <HighlightedTextInverse>Treact App.</HighlightedTextInverse></>}
      /> */}
      <Footer />
    </AnimationRevealPage>
  );
}
